import { useUserContext } from '@/context/UserContext.tsx';

export function IsInternalSales({ children }: { children: React.ReactNode }) {
  const {
    currentUser: { userType },
  } = useUserContext();

  const isInternalSales = userType === 'Internal Sales';

  return isInternalSales ? children : null;
}
